import { ApexOptions } from 'apexcharts';

export const donutOptions: ApexOptions = {
  grid: {
    padding: {
      left: 0,
      right: 0,
    },
    borderColor: 'transparent',
  },
  stroke: {
    colors: ['transparent'],
  },
  dataLabels: {
    enabled: true,
  },
  tooltip: {
    enabled: false,
  },
  legend: {
    show: true,
    position: 'bottom',
    onItemClick: {
      toggleDataSeries: false,
    },
  },
  plotOptions: {
    pie: {
      expandOnClick: false,
      donut: {
        background: 'transparent',
        labels: {
          name: {
            show: true,
          },
          value: {
            show: false,
          },
        },
      },
    },
  },
  colors: [],
  labels: [],
};

export const lineOptions: ApexOptions = {
  grid: {
    show: false,
    padding: {
      left: 0,
      right: 0,
    },
  },
  yaxis: {
    labels: {
      formatter: function (value) {
        return value.toFixed().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,') + ' M';
      },
      show: true,
      offsetX: 500,
      align: 'left',
      style: {
        colors: 'var(--color-five)',
      },
    },
    axisBorder: {
      show: true,
      offsetX: -80,
      color: 'var(--color-five)',
    },
    axisTicks: {
      show: false,
    },
    tickAmount: 6,
  },
  xaxis: {
    labels: {
      show: false,
    },
    axisBorder: {
      show: false,
    },
    axisTicks: {
      show: false,
    },
  },
  chart: {
    zoom: {
      enabled: false,
    },
    toolbar: {
      show: false,
    },
  },
  stroke: {
    show: true,
    width: 2,
    curve: 'straight',
  },
  dataLabels: {
    enabled: false,
  },
  tooltip: {
    enabled: true,
  },
  legend: {
    show: false,
    position: 'bottom',
    onItemClick: {
      toggleDataSeries: false,
    },
  },
  colors: [],
};
